import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CountryRow } from '../../../components/personalInformation/rows/CountryRow';
import { IUserService } from '../../../user.service';

export const CountryRowContainer = observer((): ReactElement => {
  const userService = useInjection(IUserService.$);

  const handleChange = async (country: string): Promise<void> => {
    const { fullName, company } = userService.data.userInfo;
    await userService.updateUserDetails(fullName, company, country);
  };

  return (
    <CountryRow
      country={userService.data.userInfo.country}
      onChange={handleChange}
    />
  );
});
